(ns manage.content-mapping-table.db
  (:require [common.db.table.backend :refer [map->InMemoryBackend]]
            [common.db.table.core :refer [register-table]]))

(def backend
  (map->InMemoryBackend {}))

(register-table
 {:namespace :table.content-mapping
  :value-sub [:form.content-variant/content-classifications]
  :initial-page {}
  :initial-search {}
  :initial-sort {}
  :backend backend})
